import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有单位信息
export const unitList = (postData) => {
  return request({
    url: '/UnitManagement/list',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据id查询
export const listGetId = (postData) => {
  return request({
    url: '/UnitManagement/getId',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据id删除
export const deleteById = (postData) => {
  return request({
    url: '/UnitManagement/deleteById',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据id进行更新
export const updateById = (postData) => {
  return request({
    url: '/UnitManagement/updateById',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据id进行状态更新
export const updateStatus = (postData) => {
  return request({
    url: '/UnitManagement/updateStatus',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 新增单位信息
export const addUnit = (postData) => {
  return request({
    url: '/UnitManagement/addUnit',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 模糊查询单位信息
export const findName = (postData) => {
  return request({
    url: '/UnitManagement/findName',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
